<template>
  <Modal closable>
    <template v-slot:header>
      <h2>{{ title }}</h2>
    </template>
    
      <p v-if="content" v-html="content"></p>

    <template v-slot:footer>
        <AppButton @click="ok()" color="primary"> Forstået </AppButton>
    </template>
  </Modal>
</template>

<script lang="ts">
import { store } from '@/store'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Message',
  props: {
    title: String,
    content: String
  },
  setup(props, { emit }) {
    function ok() {
      store.modal.hideModal('Message')
    }
    return { ok }
  }
})
</script>

<style>

</style>